<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId"  placeholder="请选择学校" @change="getData()">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary"  v-if="currUserId == 1" class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
                <el-table-column prop="schoolName" label="关联上级区县"   :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="tabTitle" label="绑定指标"   :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="areaUsersName" label="区县审核人"   :show-overflow-tooltip="true" width="130px"></el-table-column>
                <el-table-column fixed="right" label="操作" v-if="currUserId == 1" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import add from './AddAreaTeacher.vue';
    import update from './UpdateAreaTeacher.vue';

    export default {
        data(){
            return{
                loading:false,
                addVisible:false,
                updateVisible:false,
                form:{
                    deptId:"",
                },
                data:[],
                depts:[],
                currUserId:""
            }
        },
        components: {
            add,update
        },
        created:function () {
            this.getDeptData();
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.teacherAssessAreaUserListUrl;
                let data = {
                    deptId:this.form.deptId,
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.teacherAssessAreaUserRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/basis/AreaTeacher.vue